import { combineReducers } from "redux";
import authReducer from "./authReducers";
import accountReducer from "./accountReducers";
import aiWorkflowReducer from "./aiWorkflowReducers";
import infoReducer from "./infoReducer";
import loaderReducer from "./loaderReducer";
import recognitionImageReducer from "./recognitionImageReducers";
import errorReducer from "./errorReducers";
import timeoffReducer from "./timeoffReducers";
import slackReducer from "./slackReducers";
import usersReducer from "./usersReducer";

export default combineReducers({
  auth: authReducer,
  account: accountReducer,
  aiWorkflow: aiWorkflowReducer,
  info: infoReducer,
  loader: loaderReducer,
  recognitionImage: recognitionImageReducer,
  errors: errorReducer,
  timeoff: timeoffReducer,
  slack: slackReducer,
  users: usersReducer,
});
